import { h, JSX, FunctionalComponent } from 'preact';
type Icon = {
  className?: string;
  svgAttrs?: JSX.SVGAttributes<any>;
} & Partial<JSX.CSSProperties>;
const defaultStyle = {
  width: '24px',
  height: '24px',
  display: 'flex'
};

const SvgIcon = (props: JSX.SVGAttributes<any>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 21" {...props}><path fill="currentColor" stroke="currentColor" stroke-width={0.68827024} d="M14.360628 20c.170275 0 .327107-.048417.470497-.145251.179237-.123243.286779-.294903.322627-.514981.044809-.211274 0-.409343-.134428-.594208l-5.941708-8.239691 5.941708-8.252896c.134428-.176062.179237-.374131.134428-.594209-.035848-.211274-.14339-.382934-.322627-.51498-.179237-.123243-.380879-.167259-.604925-.132047-.215084.035213-.38984.145251-.524268.330116L8.08285 9.132587 2.463769 1.341853c-.125466-.184865-.300222-.294903-.524268-.330116-.215085-.035212-.416726.008804-.604925.132047-.179237.132046-.286779.303706-.322627.51498-.035847.220078.008962.418147.134428.594209l5.955151 8.252896-5.955151 8.239691c-.125466.184865-.170275.382934-.134428.594208.035848.220078.14339.391738.322627.514981.143389.096834.300222.145251.470497.145251.277817 0 .497383-.110039.658696-.330116l5.619081-7.803938 5.619082 7.803938c.161313.220077.380878.330116.658696.330116Zm17.832805 0c.224047 0 .412246-.074826.564597-.224479.161313-.158455.24197-.347722.24197-.567799 0-.211274-.080657-.396139-.24197-.554595-.152351-.149652-.34055-.224478-.564597-.224478H23.46907V1.896448c0-.220077-.076175-.404942-.228527-.554595-.161313-.158455-.349512-.237683-.564597-.237683-.224046 0-.416726.079228-.578039.237683-.152352.149653-.228527.334518-.228527.554595v17.311274c0 .220077.076175.409344.228527.567799.161313.149653.353993.224479.578039.224479h9.517487Z" /></svg>;

export const OversizedIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: '100%',
    height: '100%'
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => <span className={className} style={{ ...defaultStyle,
  ...styles
}}><SvgIcon {...svgAttrs} /></span>;